var CONSTANTS = require('./deep-link-constants'),
    CONSTANTS2 = require('./deep-link-constants2'),
    CONSTANTS3 = require('./deep-link-constants3');
var oem = {
    mazda: {
        link: 'https://www.mazdausa.com/shopping-tools/build-and-price',
        message: 'www.mazdausa.com',
        build: buildMazda
    },
    fiat: {
        link: 'http://www.fiatusa.com/hostc/bmo',
        message: 'www.fiatusa.com',
        build: buildFiat
    },
    alfa: {
        link: 'https://www.alfaromeousa.com',
        message: 'www.alfaromeousa.com',
        build: buildAlfa
    },
    chrysler: {
        link: 'http://www.chrysler.com/bridge/bmo.html',
        message: 'www.chrysler.com',
        build: buildChrysler
    },
    jeep: {
        link: 'http://www.jeep.com/bridge/bmo.html',
        message: 'www.jeep.com',
        build: buildJeep
    },
    ram: {
        link: 'http://www.ramtrucks.com/bridge/bmo.html?app=bmo',
        message: 'www.ramtrucks.com',
        build: buildRam
    },
    acura: {
        link: 'http://www.acura.com',
        message: 'www.acura.com',
        build: buildAcura
    }
};

function buildMazda(data) {
    var model = data.model;
    (model == '3') && (model = 'mazda3-' + data.submodel);
    (model == '6') && (model = 'mazda6');
    var transmission = data.transmission.slice(0,1) + data.transmission.slice(1).toLowerCase();
    var trackingURL = CONSTANTS.TRACKING[data.niceName][data.model][data.submodel].link,
        timestamp = window.EDM.PageValues.page.timestamp;
    return trackingURL.replace('[timestamp]', timestamp) + '&ru=' +
        encodeURI(oem[data.niceName].link + '/' + model +
        '#s=' + data.pageNumber +
        '&tr=' + transmission +
        '&d=' + data.driveTrain +
        '&t=' + data.code +
        '&ex=' + data.extColor +
        '&in=' + data.intColor +
        '&p=' + data.package +
        '&ip=&o=' + data.option + '&io=');
}
function buildFiat (data) {
    var model = 'CUX' + data.year;
    (data.model == '500') && (model += '01');
    (data.model == '500e') && (model += '04');
    switch(data.model) {
    case '500l': model += '05'; break;
    case '500x': model += '06'; break;
    case '124-spider': model += '07'; 
    }
    var fiatLink = oem[data.niceName].link + '/' + model + '/models.do';
    var trackingURL = (CONSTANTS3.TRACKING[data.niceName][data.model]) ? CONSTANTS3.TRACKING[data.niceName][data.model].link + '?' : '';
    return trackingURL + encodeURI(fiatLink);
}
function buildAlfa(data) {
    var modelLink = oem[data.niceName.split('-')[0]].link,
        trackingURL = (CONSTANTS2.TRACKING[data.niceName][data.model]) ? CONSTANTS2.TRACKING[data.niceName][data.model].link + '?' : '';
    if(data.year == '2017') {
        modelLink += '/cars/';
        if(data.model == 'giulia') {
            modelLink += 'alfa-romeo-giulia-quadrifoglio.gotostyle';
        } else {
            modelLink += data.model.toUpperCase() + '-' +  data.submodel;
        }
    } else {
        modelLink += '/build-and-price/' + data.model.toUpperCase() + '-' +  data.submodel + '/' + data.year;
    }
    return trackingURL + encodeURI(modelLink);
}
function buildChrysler(data) {
    var trackingURL,
        chryslerLink = oem[data.niceName].link + '?family=' + data.model + '&year=' +  data.year;
    if(data.year == '2017' || data.year == '2016') {
        trackingURL = (CONSTANTS3.TRACKING[data.niceName][data.model]) ? CONSTANTS3.TRACKING[data.niceName][data.model].link + '?' : '';
    }

    return trackingURL + encodeURI(chryslerLink);
}
function buildJeep(data) {
    var modelLink = oem[data.niceName].link + '?family=' + data.model.replace(/-/g, '_') + '&year=' + data.year;
    if (data.year == '2016' || data.year == '2017') {
        var trackingURL = CONSTANTS2.TRACKING[data.niceName][data.model] ? CONSTANTS2.TRACKING[data.niceName][data.model].link : '';
        if (trackingURL == '' && CONSTANTS2.TRACKING[data.niceName]['']) {
            trackingURL = CONSTANTS2.TRACKING[data.niceName][''].link;
        }
        modelLink = trackingURL + '?' + encodeURI(modelLink);
    }
    return modelLink;
}
function buildRam(data) {
    return oem[data.niceName].link + '&year=' + data.year + '&vehicle=' + data.id;
}
function buildAcura(data) {
    if(data.year == '2016') {
        return null;
    }

    var acuraLink = oem[data.niceName].link,
        trackingURL = (CONSTANTS2.TRACKING[data.niceName][data.model]) ? CONSTANTS2.TRACKING[data.niceName][data.model].link + '?' : '';
    if (data.year == '2017') {
        acuraLink += '/build-price/' + data.model;
    } else {
        acuraLink += '/tools/bap/build.aspx?ProductLineName=' + data.model + '&modelYear=' + data.year;
    }
    if (data.model == 'NSX') {
        acuraLink = 'http://nsx.acura.com/build';
    }
    return trackingURL + encodeURI(acuraLink);
}

module.exports = {
    oem1: oem,
    buildMazda: buildMazda,
    buildFiat: buildFiat,
    buildAlfa: buildAlfa,
    buildChrysler: buildChrysler,
    buildJeep: buildJeep,
    buildRam: buildRam,
    buildAcura: buildAcura
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/deep-link/deep-link-data.js
// module id = 184
// module chunks = 0 1 23